import {Event} from "./event";
import {TournamentPlayer} from "./tournamentPlayer";

export class Tournament {
  id: number;
  name: string;
  date: string;
  status: string;
  events: Event[];
  tournamentPlayers: TournamentPlayer[];
  maxEvents: number = 2;
  costsPerEvent: number[] = [10, 20, 0];
  courts: number;
  active: boolean;
  playersPlaying: number[];
  playersCounting: number[];
  playersAvailable: number[];

  static getStatus(tournament: Tournament): string {
    if (tournament.status == "CLOSED") return "Afgerond";
    if (tournament.status == "DIVIDED") return "Ingedeeld";
    if (tournament.status == "DRAWN") return "Geloot";
    if (tournament.status == "ONGOING") return "Bezig";
    return "Nieuw";
  }

}
